export const en = {
    'avg-click-price-mandatory': 'Average CPC is not specified',
    'avg-cpc-ratio-weekly-budget-limit-error':
        'Increase your weekly budget. The weekly budget must be enough for at least {limit} conversions.',
    'invalid-profitability': 'The production costs percentage must be between {from} and {to}',
    'roi-coef-mandatory': 'ROI is not specified',
    'too-big-avg-click-price': 'Average CPC must not exceed {limit} {currency}',
    'too-big-avg-cpa-price': 'Average CPA must not exceed {limit} {currency}',
    'too-big-daily-budget': 'Daily budget must not exceed {limit} {currency}',
    'too-big-max-click-price': 'Maximum CPC must not exceed {limit} {currency}',
    'too-big-week-bundle': 'Number of clicks per week must not exceed {limit}',
    'too-big-weekly-budget': 'Weekly budget must not exceed {limit} {currency}',
    'too-small-avg-click-price': 'Average CPC must not be less than {limit} {currency}',
    'too-small-avg-cpa-price': 'Average CPA must not be less than {limit} {currency}',
    'too-small-daily-budget': 'Daily budget must not be less than {limit} {currency}',
    'too-small-max-click-price': 'Maximum CPC must not be less than {limit} {currency}',
    'too-small-roi-coef': 'ROI must be greater than {limit}',
    'too-small-week-bundle': 'Number of clicks per week must be at least {limit}',
    'too-small-weekly-budget': 'Weekly budget must not be less than {limit} {currency}',
    'week-bundle-mandatory': 'Number of clicks is not specified',
    'weekly-budget-mandatory': 'Weekly budget is not specified'
};
